import styled from '@emotion/styled';
import { Card as BsCard, Button as BsButton } from 'react-bootstrap';

export const CalendarCard = styled(BsCard)`
    margin-bottom: 1.5rem;
`;

export const CalendarCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ProviderInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`;

export const ProviderIconWrapper = styled.div`
    font-size: 1.5rem;
    color: #fff;
`;

export const CalendarTitle = styled.h5`
    margin: 0;
    font-weight: 600;
`;

export const StatusBadge = styled.span`
    font-weight: 600;
    color: ${({ isActive }) => (isActive ? '#10B981' : '#EF4444')};
`;

export const SyncDirectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
    gap: 1rem;
`;

export const StyledButton = styled(BsButton)`
    min-width: 120px;
    &:disabled,
    &.disabled {
        pointer-events: none;
        opacity: 0.6;
        cursor: not-allowed;
    }
`;
